import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'button-container',
	templateUrl: './button-container.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['button-container.widget.scss'],
})
export class ButtonContainerWidget {
}
